
import React from "react";
import { Button } from "@/components/ui/button";
import { Gift, Award, Check } from "lucide-react";

interface PointsControlsProps {
  availablePoints: {
    daily: boolean;
    weekly: boolean;
  };
  claimPoints: (type: 'daily' | 'weekly') => Promise<void>;
}

const PointsControls: React.FC<PointsControlsProps> = ({ availablePoints, claimPoints }) => {
  return (
    <div className="mt-6 grid grid-cols-2 gap-3">
      <Button 
        variant={availablePoints.daily ? "default" : "outline"}
        size="sm"
        disabled={!availablePoints.daily}
        onClick={() => claimPoints('daily')}
        className={`hover:shadow-md transition-all ${availablePoints.daily ? 'bg-blue-500 hover:bg-blue-600' : ''}`}
      >
        {availablePoints.daily ? (
          <>
            <Gift className="h-4 w-4 mr-2" />
            Daily +10
          </>
        ) : (
          <>
            <Check className="h-4 w-4 mr-2" />
            Claimed
          </>
        )}
      </Button>
      
      <Button 
        variant={availablePoints.weekly ? "default" : "outline"} 
        size="sm"
        disabled={!availablePoints.weekly}
        onClick={() => claimPoints('weekly')}
        className={`hover:shadow-md transition-all ${availablePoints.weekly ? 'bg-purple-500 hover:bg-purple-600' : ''}`}
      >
        {availablePoints.weekly ? (
          <>
            <Award className="h-4 w-4 mr-2" />
            Weekly +25
          </>
        ) : (
          <>
            <Check className="h-4 w-4 mr-2" />
            Claimed
          </>
        )}
      </Button>
    </div>
  );
};

export default PointsControls;
